














































































/* General */

/* Mixins */
import SearchableDropdownMixin from '@/mixins/searchable-dropdown.mixin'

/* Components */

/* Helpers */

/* Data types */
import { IPersonBase } from '@/api/types/response.types'

/* API */
import InternalProjectsAPI from '@/api/modules/internal-projects.api'
import TasksAPI from '@/api/modules/tasks.api'

export default SearchableDropdownMixin.extend({
  name: 'IfpFilterCreators',

  props: {
    projectId: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      isPrefetchingLoneCreator: false,
      creatorsLoaded: false,
      creators: [] as IPersonBase[],
      prefetchedLoneCreator: null as IPersonBase,

      /* SearchableDropdownMixin configuration */
      allowMultipleSelections: true,
    }
  },

  computed: {
    totalOptionsCount(): number {
      return this.creators.length
    },
    filteredOptions(): IPersonBase[] {
      if (this.filterQuery.length === 0) {
        return this.creators
      }

      return this.creators.filter(person => {
        return person.name
          .toLowerCase()
          .includes(this.filterQuery.toLowerCase())
      })
    },
    hasLoneCreatorSelection(): boolean {
      return this.selectedCreators.length === 1
    },
    hasSelectedCreators(): boolean {
      // Unvetted from backend, for eager label display...
      return this.selectedCreators.length > 0
    },
    hasSelectedIDs(): boolean {
      // Unvetted from backend, for eager label display...
      return this.selectedIds.length > 0
    },
    hasOneSelectedID(): boolean {
      // Unvetted from backend, for eager label display...
      return this.selectedIds.length === 1
    },
    selectedCreators(): IPersonBase[] {
      if (!this.creatorsLoaded) {
        return []
      }
      return this.creators.filter(c => this.selectedIds.includes(c.id))
    },
  },

  watch: {
    selectedIds: {
      immediate: true,
      handler() {
        // Prefetch the one creator for the value display
        if (!this.creatorsLoaded) {
          if (this.hasOneSelectedID) {
            this.prefetchLoneCreator(this.selectedIds[0])
          }
        }
      },
    },
  },

  methods: {
    async getCreators() {
      if (this.creatorsLoaded) {
        return
      }
      try {
        if (this.projectId) {
          this.creators = await InternalProjectsAPI.get_Creators(this.projectId)
        } else {
          this.creators = await TasksAPI.get_AllCreators()
        }
        this.creatorsLoaded = true
      } catch (error) {
        this.$error.emit(error, true)
      }
    },
    async prefetchLoneCreator(id: number) {
      try {
        this.isPrefetchingLoneCreator = true
        this.prefetchedLoneCreator = await TasksAPI.get_CreatorContactInfo(id)
        return
      } catch (error) {
        // If we're here, the creator ID doesn't exist. Clear it...
        this.clearSelectedIDs()
      } finally {
        this.isPrefetchingLoneCreator = false
      }
    },
    handleClearClick() {
      this.clearSelectedIDs()
    },
  },
})
